import { DomItem, getDatePosition, getDefaultScrollPosition, isUndefinedOrNull, ITimelineContext, TimelineState, TimelineViewModel, TimelineViewState, viewState } from "../../omnia"
import { getContextMenuPosition } from "../contextMenu"
import { toggleItemSelection } from "../selection"

type IDomItem = omnia.fields.timeline.IDomItem

export import convertStyle = omnia.react.convertStyle

export function setupScrollState(state: TimelineViewState, vm: TimelineViewModel) {

    const scroll = state.scroll = state.scroll ?? viewState.scroll

    if (isUndefinedOrNull(scroll.scrollLeft)) {

        scroll.scrollLeft = getDefaultScrollPosition(vm.cropYear, d => getDatePosition({
            viewConfig: vm.viewConfig,
            startDate: vm.startDate
        }, d))

    }

}

export function closePopup(state: TimelineState, apply: Function) {

    if (state.controller.popupContext) {
        state.controller.popupContext = null
        apply()
    }

}

export function createEventHandlers(context: ITimelineContext, state: TimelineState, apply: Function, getRootElt: () => HTMLElement) {

    const { vm, controller } = state

    return {

        onPointerDown: (event: React.PointerEvent, target: IDomItem) => {
            handleItemClicked(target, event, getRootElt)
            event.stopPropagation()
        }

    }

    function handleItemClicked(item: IDomItem, event: React.PointerEvent, getRootElt: () => HTMLElement) {

        const popup = (() => {

            if (item && item.disabled) {
                return undefined
            }

            if (controller.isEditing() && (item instanceof DomItem)) {
                toggleItemSelection(controller, item)
                apply()
                return null
            }

            if (controller.isDragging) {
                return null
            }

            if (event.button != 2) {
                return null
            }

            const root = getRootElt()
            const position = getContextMenuPosition(root, event.clientX, event.clientY)

            return {
                context,
                timeline: state.controller,
                target: item.target,
                targetWidth: item.width,
                ...position
            }

        })()

        if (popup === undefined) return

        state.controller.popupContext = popup
        apply()

    }


}
